import { nl as reactnl } from '@ews/react-translations';

const nl = {
...reactnl
}
export default nl
